export default {
      id: "barres_laterales-usage",
      viewBox: "0 0 18 327",
      url: "../dist/images/" + "sprite.svg#barres_laterales-usage",
      toString: function () {
        return this.url;
      }
    }